import React, { useEffect, useState } from "react";
import ErrorModal from "../../components/Error/Error";
import Loading from "../../components/Loading/Loading";
import VideoZoom from "../../components/VideoZoom/VideoZoom";
import CustomModal from "../PopUp/CustomModal";
import { useData } from "../../context/DataProvider";
import styles from "./HomePage.module.scss";
import { PopUpPageService } from "../../services/popuppageadmin.service";

const rowPatterns =
  window.innerWidth <= 425
    ? [[100], [100], [100], [100], [100], [100]]
    : [
        [36.7, 31.65, 31.65],
        [27.35, 33.85, 38.8],
        [38.55, 33.85, 27.6],
        [27.35, 33.85, 38.8],
      ];

const HomePage: React.FC = () => {
  const { homePageData: items2, isLoading, error } = useData();
  const [videoZoomVisible, setVideoZoomVisible] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);

  // 👇 Yeni eklenen state: Modalda gösterilecek popup verisi
  const [popupData, setPopupData] = useState<any>(null);

  useEffect(() => {
    const fetchPopup = async () => {
      try {
        const response = await PopUpPageService.popupListele();

        if (Array.isArray(response?.data)) {
          // status === 1 olan ilk popup'ı al
          const activePopup = response.data.find((item) => item.status === 1);
          if (activePopup) {
            setPopupData(activePopup);
            setShowModal(true); // sadece veri geldiyse modalı göster
          }
        }
      } catch (err) {
        console.error("Popup verisi alınamadı:", err);
      }
    };

    fetchPopup();
  }, []);

  if (isLoading) return <Loading />;
  if (error) return <ErrorModal message={error.message} />;

  const sortedItems = [...items2].sort((a, b) => a.sira - b.sira);

  const allRows = [];
  let currentIndex = 0;
  let patternIndex = 0;

  while (currentIndex < sortedItems.length) {
    const widths = rowPatterns[patternIndex];
    const itemCount = widths.length;
    const rowItems = sortedItems.slice(currentIndex, currentIndex + itemCount);

    allRows.push({ widths, items: rowItems });
    currentIndex += itemCount;
    patternIndex = (patternIndex + 1) % rowPatterns.length;
  }

  return (
    <div className={styles.homepageContainer}>
      {allRows.map((row, rowIndex) => (
        <div key={rowIndex} className={styles.row}>
          {row.items.map((item, itemIndex) => {
            const width = row.widths[itemIndex];

            return (
              <div
                key={item.id}
                className={styles.item}
                style={{ width: `${width}%` }}
              >
                {item.dosyaTip?.includes(".mp4") ? (
                  <div className={styles.videoContainer}>
                    <video
                      src={item.dosya}
                      style={{ cursor: "pointer" }}
                      autoPlay
                      muted
                      loop
                      className={styles.video}
                      onClick={() => {
                        setVideoZoomVisible(true);
                        setSelectedVideo(item.dosya);
                      }}
                    />
                  </div>
                ) : (
                  <img
                    src={item.dosya}
                    alt={item.baslik}
                    style={{ cursor: item.url ? "pointer" : "default" }}
                    onClick={() => {
                      if (item.url) {
                        window.location.href = item.url;
                      }
                    }}
                    className={styles.image}
                  />
                )}
              </div>
            );
          })}
        </div>
      ))}

      {videoZoomVisible && selectedVideo && (
        <VideoZoom
          src={selectedVideo}
          onClose={() => {
            setVideoZoomVisible(false);
            setSelectedVideo(null);
          }}
        />
      )}

      {/* Sayfa açılınca çıkan modal (dinamik içerik ile) */}
      <CustomModal isOpen={showModal} onClose={() => setShowModal(false)}>
        {popupData ? (
          <>
            <a href={popupData.onClickUrl}>
            <img src={popupData.popupGorsel} />
            </a>
            <div dangerouslySetInnerHTML={{ __html: popupData.aciklama, }} />
          </>
        ) : (
          <p>
            Bu sayfa açıldığında gösterilen bilgilendirici bir modal örneğidir.
          </p>
        )}
      </CustomModal>
    </div>
  );
};

export default HomePage;
